<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Контент</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактирование</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="mb-4">
            <div class="form-label">Тип контента</div>
            <input type="text" class="form-control" v-model="type_name" disabled>
        </div>

        <div class="mb-4">
            <label class="form-label">Введите название</label>
            <input type="text" class="form-control" placeholder="..." v-model="name">
        </div>

        <div class="mb-4">
            <label class="form-label">Введите продолжительность</label>
            <input type="time" step="1" class="form-control" placeholder="..." id="content-duration" v-model="duration">
        </div>

        <div class="form-check mb-4">
            <label class="form-check-label" for="is_statistics_enabled">
                Сбор статистики показов
            </label>
            <input class="form-check-input" type="checkbox" value="" id="is_statistics_enabled" v-model="is_statistics_enabled">
        </div>

        <div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
            <button class="btn btn-lg btn-primary me-3" v-on:click="updateContent()">
                Сохранить
            </button>
            <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
        </div>
    </div>
</template>

<script>

import Content from "../../../../models/Content";
import FileUploadElement from "../../../../elements/FileUploadElement.vue";

export default {
    name: "ContentEditComponent",
    components: {
        FileUploadElement
    },
    props: {
        route_back: String,
        route_update: String,
        route_get: String,
        content_id: {
            type: Number,
            default: 0
        }
    },
    data: function () {
        return {
            content: new Content({
                route_update: this.route_update,
                route_get: this.route_get,
            }),
            file: undefined,
            name: '',
            type: 0,
            type_name: '',
            duration: null,
            is_statistics_enabled: false,
            picture_path: '',
            client_id: null,
            brand_id: null,
            contentTypes: [
                {
                    id: 1,
                    name: 'Изображение'
                },
                {
                    id: 2,
                    name: 'Видео'
                }
            ]
        }
    },
    methods: {
        itemGet: async function () {
            let item = await this.content.get(this.content_id);
            this.name = item.name;
            this.type = item.type_id;
            this.type_name = item.type_name
            this.duration = item.duration;
            this.is_statistics_enabled = item.is_statistics_enabled;
            this.picture_path = item.path;
        },
        updateContent: async function () {
            let formData = new FormData();
            formData.append('name', this.name);
            formData.append('duration', this.duration);
            formData.append('is_statistics_enabled', this.is_statistics_enabled);
            formData.append('id', this.content_id.toString());

            let result = await this.content.update(formData);
            if (result) {
                window.location.href = this.route_back;
            } else {
                console.log('error: update_content');
            }
        },
        fileUpload: function (e) {
            if (e !== false) {
                this.file = e.target.files[0];
            } else {
                this.file = undefined;
            }
        },
    },
    mounted() {
        this.itemGet();
    }
}
</script>

<style scoped>
    .form-check {
        display: block !important;
    }
</style>
